var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{on:{"click":_vm.triggerError}},[_vm._v("Trigger Error")]),_vm._v(" "),_c('button',{on:{"click":_vm.triggerErrorHelper}},[_vm._v("Trigger Error Via Helper")])])
}
var staticRenderFns = []

export { render, staticRenderFns }